<template>
  <div @click="showInfo">
    <div class="item">
      <div class="invoicerow">
        <div class="column info">
          <div class="information">
            <div class="command log">
              <corner-up-right-icon v-if="item.command == 'MONM'" size="1.2x" class="custom-class"></corner-up-right-icon>
              <edit3-icon v-else-if="item.command == 'RENM'" size="1.2x" class="custom-class"></edit3-icon>
              <download-icon v-else-if="item.command == 'DOWM'" size="1.2x" class="custom-class"></download-icon>
              <trash2-icon v-else-if="item.command == 'DENM'" size="1.2x" class="custom-class"></trash2-icon>
              <info-icon v-else size="1.2x" class="custom-class"></info-icon>
              <p>{{ action }}</p>
            </div>
            <div class="node-name log">
              <file-icon size="1.2x" class="custom-class"></file-icon>
              <p v-if="item.node" :title="item.node.name">{{ item.node.name }}</p>
              <p v-else-if="item.currentNode" :title="item.currentNode.name">{{ item.currentNode.name }}</p>
              <p v-else :title="item.handle">{{ item.handle }}</p>
            </div>
            <div class="ctime log">
              <calendar-icon size="1.2x" class="custom-class"></calendar-icon>
              <p>{{ humanTime }}</p>
            </div>
            <div class="sessionip log">
              <monitor-icon size="1.2x" class="custom-class"></monitor-icon>
              <p>{{ item.ip }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import { MonitorIcon, CalendarIcon, FileIcon, InfoIcon, CornerUpRightIcon, DownloadIcon, Edit3Icon, Trash2Icon } from 'vue-feather-icons';
import moment from 'moment';
import i18n from '@/i18n';

export default {
  name: 'item',
  data: function () {
    return {
      timer: 0,
      isShow: false,
      action: ''
    };
  },
  components: {
    MonitorIcon,
    CalendarIcon,
    FileIcon,
    InfoIcon,
    CornerUpRightIcon,
    DownloadIcon,
    Edit3Icon,
    Trash2Icon
},
  props: ['item'],
  computed: {
    humanTime() {
      return moment(this.item.ctime * 1000).format('DD/MM/YY HH:mm');
    },
  },
  mounted () {
    switch (this.item.command) {
      case 'DOWM': 
        this.action = i18n.t('prompts.download');
        break;
      case 'RENM':
        this.action = i18n.t('buttons.update');
        break;
      case 'DENM':
        this.action = i18n.t('buttons.delete');
        break;
      case 'MONM':
        this.action = i18n.t('buttons.move');
        break;
      default: 
        this.action = '';
        break;
    }
  },
  methods: {
    showInfo() {
      this.$store.commit('showHover', {prompt: 'show-info-log', data: this.item});
    }
  }
};
</script>